import { sendCodeTimeKey } from '@/config/base';
// @ts-ignore
import { removeLocalStorage, removeToken, setToken } from '@/utils/cookies';
import {
  Button,
  Radio,
  RadioChangeEvent,
  Space,
  Spin,
  message,
} from '@sinohealth/butterfly-ui-components';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { switchChain } from '../../http';
import styles from './index.less';

type SelectOrganizationProps = {
  /** 选择机构的title */
  organizaTitle?: string;
  /** 白色背景 */
  white?: boolean;
  /** token */
  token?: string;
  /** 机构数据 */
  source: any[];
  /** 确认选择 */
  onOk?: () => void;
  /** 取消选择 */
  onCancel?: () => void;
};

/** 选择机构 */
const SelectOrganization: React.FC<SelectOrganizationProps> = (props) => {
  const { organizaTitle, white, source, token, onOk, onCancel } = props;

  const navigate = useNavigate();

  const [value, setValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleOk = () => {
    if (!value) {
      message.error('请选择机构');
      return;
    }
    setIsLoading(true);
    httpSwitchChainReq(value);
  };

  const httpSwitchChainReq = async (v: string) => {
    try {
      console.log(token);
      await switchChain(v, { token });
      navigate('/');
      setToken(token || '');
      onOk && onOk();
      removeLocalStorage(sendCodeTimeKey);
    } finally {
      setIsLoading(false);
    }
  };

  const onChange = (e: RadioChangeEvent) => {
    setValue(e.target.value);
    setIsLoading(false);
  };

  useEffect(() => {
    if (source.length === 0) {
      message.error('没有关联机构');
      removeToken();
    }
    if (source.length === 1) {
      setValue(source[0].id);
      httpSwitchChainReq(source[0].id);
    }
  }, [source]);

  return source.length > 1 ? (
    <Spin spinning={isLoading} tip="登录中, 请稍候">
      <div className={styles['choose-organization']}>
        <div>
          <div className={styles['choose-title']}>{organizaTitle || '选择机构'}</div>
          <Radio.Group className={styles.container} onChange={onChange} value={value}>
            <Space direction="vertical">
              {source.map((el) => (
                <div
                  key={el.id}
                  className={`${styles['organization-list']} ${
                    white ? styles['list-border'] : ''
                  } ${value === el.id ? styles['organization-active'] : ''}`}
                  onClick={() => setValue(el.id)}
                >
                  <span>{el.name}</span>
                  <Radio value={el.id} />
                </div>
              ))}
            </Space>
          </Radio.Group>
        </div>
        <div style={{ paddingTop: 20, display: 'flex' }}>
          <Button
            block
            style={{ marginRight: 16 }}
            size="large"
            onClick={() => {
              onCancel && onCancel();
              removeLocalStorage(sendCodeTimeKey);
            }}
          >
            返回登录
          </Button>
          <Button
            className={`${value !== '' ? styles['custom-btn'] : ''}`}
            type="primary"
            disabled={value === ''}
            block
            size="large"
            onClick={() => handleOk()}
          >
            开始工作
          </Button>
        </div>
      </div>
    </Spin>
  ) : null;
};

export default SelectOrganization;
